import Title from '@/components/Title';
import LeadButton from '@/components/LeadButton';
import React, { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const VideoArea = () => {
  const { t, i18n } = useTranslation(['home', 'path', 'math']);

  const tagList = useMemo(() => {
    if (i18n?.language === 'zh') {
      return [
        {
          label: t('math:数学名师真人授课'),
          id: 0,
        },
        {
          label: t('math:高频互动在线小班'),
          id: 1,
        },
        {
          label: t('math:科学分级版权课程'),
          id: 2,
        },
        {
          label: t('math:全英文教学'),
          id: 3,
        },
        {
          label: t('math:覆盖全球24个时区'),
          id: 4,
        },
      ];
    }
    return [
      {
        label: t('math:数学名师真人授课'),
        id: 1,
        hidden: i18n?.language === 'en',
      },
      {
        label: t('math:高频互动在线小班'),
        id: 2,
      },
      {
        label: t('math:科学分级的版权课程'),
        id: 3,
      },
      {
        label: t('math:数学全英文教学'),
        id: 4,
      },
      {
        label: t('math:覆盖全球24个时区'),
        id: 5,
      },
    ];
  }, [i18n?.language]);

  return (
    <div>
      <div className="container relative mt-[5rem] lg:mt-[140px] xl:mt-[200px]">
        <Title theme="math" innerHTML>
          {t('math:title-随时随地')}
        </Title>
      </div>
      <section className="container mt-[1.5rem] flex flex-wrap justify-center gap-[12px] text-[20px] lg:mt-[24px] lg:gap-x-[20px] lg:gap-y-[12px] xl:mt-[40px] xl:gap-x-[24px] xl:gap-y-[12px] xl:text-[20px]">
        {tagList.map((item) => {
          if (item.hidden) {
            return null;
          }
          return (
            <h3
              className="flex items-center rounded-[999px] bg-[linear-gradient(89deg,rgba(0,132,230,0.12)_0.83%,rgba(177,129,255,0.12)_99.22%),linear-gradient(180deg,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.90)_100%)] p-[4px_12px] text-center text-[14px] text-wk-words-1 lg:text-[16px] xl:text-[20px]"
              key={item.id}
            >
              {item.label}
            </h3>
          );
        })}
      </section>
      <div className="container mx-auto mt-[24px] lg:mt-[32px] xl:mt-[60px]">
        <video
          className="video1 block h-full w-full  rounded-xl border-[2px] border-[#DFE0ED] bg-black object-cover  lg:rounded-[27px] lg:border-[5px] xl:rounded-5xl xl:border-[6px]"
          src={`https://cdnwukong.com/public/wk-official-site/video/math_propagandize_${i18n?.language || 'en'}_20241205.mp4`}
          controlsList="nodownload"
          playsInline
          x5-video-player-fullscreen="false"
          x5-playsinline="true"
          webkit-playsinline="true"
          loop
          autoPlay
          muted
          contextMenu="return false"
          disablePictureInPicture
          controls
        />
      </div>
      <div className="mt-[1.5rem] text-center lg:mt-[48px] xl:mt-[60px]">
        <LeadButton
          theme="math"
          size="xl"
          subject="math"
          className=""
          traceName="O_MathCourse_ClassroomVideo_CTAClick"
          traceGa4Name="new_entry_MathCourse_ClassroomVideoCTA"
        >
          {t('banner-按钮')}
        </LeadButton>
      </div>
    </div>
  );
};

export default VideoArea;
